import React from "react";
import { FormGroup } from "../../models/models";
import FormGroupCompnent from "./FormGroupComponent";
import { useFormikContext } from "formik";

export default function FormCreatorComponent({ formBody }: { formBody: FormGroup }) {
  const { values } = useFormikContext();
  return (
    <FormGroupCompnent
      parentKey=""
      parentvalues={values}
      elementKey={formBody.key}
      label={formBody.label}
      fields={formBody.fields}
      warn={formBody.warn}
      hideExpression={formBody.hideExpression}
      disabledExpression={formBody.disabledExpression}
      customWrapper={formBody.customWrapper}
      heading={formBody.heading}
      classNameOpt={formBody.classNameOpt}
      rest={formBody.props}
      test={formBody.test}
    />
  );
}
